import ToolTip from "@components/Tooltip";
import {
  makeSelectIsAvailableVariant,
  makeSelectOne,
  makeSelectVariantTest,
} from "@features/publicPage/schemeDetails/selectors";
import { setSelectVarirant } from "@features/publicPage/schemeDetails/slice";
import { returnImgSrc } from "@utils/helpers";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PriceComponent from "./PriceComponent";
import { useState } from "react";
import Dialog from "@components/Dialog";
import { IMAGE_BASE } from "@utils/constants";
import { RiExternalLinkFill, RiExternalLinkLine } from "react-icons/ri";

const PublicProductCard = ({ value, quantity, is_bundled = false }) => {
  const [openDesc, setOpenDesc] = useState(false);

  const dispatch = useDispatch();
  const variantTest = useSelector(makeSelectVariantTest);
  const one = useSelector(makeSelectOne);
  const variant_id = one?.variant_id || {};

  const isAvailbleToBuy = useSelector(makeSelectIsAvailableVariant);

  const handleSelectVariant = (inventory_type, inventory_value) => {
    dispatch(setSelectVarirant({ inventory_type, inventory_value }));
  };

  const isMatchingInv = (inventory_type, val) => {
    if (variantTest[inventory_type] === val?.trim()) {
      return true;
    }
    return false;
  };

  const handleToggleOpenDesc = () => {
    setOpenDesc((prev) => !prev);
  };

  return (
    <>
      <div className='border border-gray-300 px-4 py-2.5 rounded'>
        <div className='relative'>
          <Link
            to={`${IMAGE_BASE}${value?.image?.[0]?.document?.path}`}
            target='_blank'
            className='text-blue-500 absolute right-0 border rounded-full p-1 border-blue-500 hover:shadow'
          >
            <RiExternalLinkLine />
          </Link>
          <img
            src={returnImgSrc(value?.image?.[0]?.document)}
            alt={value?.name}
            className='object-contain h-32 w-full mx-auto'
          />
        </div>
        <div className='font-semibold block truncate mt-3 line-clamp-2'>
          {value.name}
        </div>
        <div className='mt-1'>{value.sku_from_system}</div>
        <button
          onClick={handleToggleOpenDesc}
          className='text-blue-500 hover:text-blue-600 mt-1 hover:underline'
        >
          View Description
        </button>
        {!is_bundled ? (
          <>
            {value?.is_multiple_variation && (
              <>
                <div className='mt-2'>
                  <div className='text-primary flex items-center gap-1'>
                    Select Varirant of the Product
                    <ToolTip toolTipContent='This product has multiple variants.' />
                    :
                  </div>
                  <div>
                    {value?.inventory_type.map((each, index) => (
                      <div key={each.inventory_type} className='mt-1 last:pb-2'>
                        <div className='mr-3 capitalize mb-1.5 text-xs'>
                          {each.inventory_type} :
                        </div>
                        <div className='flex flex-wrap gap-2 flex-1 items-center'>
                          {each.option.map((type_val, ind) => (
                            <button
                              role='button'
                              key={type_val + ind}
                              className={
                                "px-2 py-px cursor-pointer rounded border " +
                                `${
                                  isMatchingInv(each.inventory_type, type_val)
                                    ? "border-1 border-primary text-primary font-medium"
                                    : "border-gray-300 font-medium text-gray-600"
                                }` +
                                " disabled:cursor-not-allowed disabled:opacity-60"
                              }
                              onClick={() =>
                                handleSelectVariant(
                                  each.inventory_type,
                                  type_val?.trim()
                                )
                              }
                            >
                              {type_val}
                            </button>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
            {!isAvailbleToBuy && (
              <div className='mt-1 text-danger'>
                This variant is not available right now. Please select another
                variant.
              </div>
            )}
            {variant_id && (
              <div className='flex justify-end'>
                <PriceComponent
                  price={variant_id?.price}
                  sales_price={variant_id?.sales_price}
                />
              </div>
            )}
          </>
        ) : (
          <>
            <div className='flex justify-end'>
              <PriceComponent
                price={value?.variant?.[0]?.price}
                sales_price={value?.variant?.[0]?.sales_price}
              />
            </div>
          </>
        )}
      </div>
      <Dialog
        opened={openDesc}
        title={`Product Description of ${value?.name}`}
        onClose={handleToggleOpenDesc}
        size='70%'
      >
        <p
          dangerouslySetInnerHTML={{
            __html: value?.description,
          }}
        />
      </Dialog>
    </>
  );
};

export default PublicProductCard;
